export const mapBlankToNull = (data: string | undefined | null) =>
  data === undefined || data === null || data.trim().length === 0 ? null : data;

export const formatGPSField = (
  latitude: string | number | null,
  longitude: string | number | null,
) => (latitude && longitude ? `${latitude}, ${longitude}` : '-');

export const arraysEqual = (a: any[] | undefined, b: any[] | undefined): boolean => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  for (let i = 0; i < sortedA.length; i++) {
    if (sortedA[i] !== sortedB[i]) return false;
  }
  return true;
};
